import { trpc } from "@/lib/trpc";

export const useAuthProvidersQuery = (enabled: boolean = true) => {
    return trpc.authProviders.findAll.useQuery(undefined, { enabled });
};

export const useAuthProviderByIdQuery = (id: string, enabled: boolean = true) => {
    return trpc.authProviders.findById.useQuery({ id }, { enabled: !!id && enabled });
};

export const useAuthProviderQuery = (provider: string, enabled: boolean = true) => {
    return trpc.authProviders.findByProvider.useQuery({ provider }, { enabled: !!provider && enabled });
};

export const useEnabledAuthProviderQuery = (enabled: boolean = true) => {
    return trpc.authProviders.findEnabled.useQuery(undefined, { enabled });
};

export const useEnabledAuthProviderPublicQuery = (enabled: boolean = true) => {
    return trpc.authProviders.findEnabledPublic.useQuery(undefined, { enabled });
};
